import { FC, useState, ChangeEvent } from 'react'
import { StyleInput, StyleIconWrapper } from './style'
import {
  StyleFormWrapper,
  StyleLabel,
  StyleErrorMessage,
  StyleInputWrapper,
} from '../style'
import { Field } from 'formik'
import Svg from '../../svg'
interface InputProps {
  label?: string
  name: string
  placeholder?: string
  editable?: boolean
  onChangeText?: (text: string) => void
  styleInput?: string
  styleLabel?: string
  styleWrapper?: string
}
const Password: FC<InputProps> = ({
  label,
  name,
  styleLabel,
  styleWrapper,
  ...restProps
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [isFocus, setIsFocus] = useState<boolean>(false)
  const handleChange = ({ form, value }: any) => {
    form.setFieldValue(name, value)
  }
  return (
    <Field name={name}>
      {({ form, meta }: any) => {
        const hasError = !!meta.touched && !!meta.error
        return (
          <StyleFormWrapper styleWrapper={styleWrapper}>
            {!!label && (
              <StyleLabel hasError={hasError} styleLabel={styleLabel}>
                {label}
              </StyleLabel>
            )}
            <StyleInputWrapper>
              <StyleInput
                isFocus={isFocus}
                hasError={hasError}
                type={!isVisible ? 'password' : 'text'}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  handleChange({
                    form,
                    value: event.target.value,
                  })
                }}
                onFocus={() => {
                  setIsFocus(true)
                }}
                onBlur={() => {
                  setIsFocus(false)
                }}
                {...restProps}
              />
              <StyleIconWrapper onClick={() => setIsVisible(!isVisible)}>
                {!!isVisible ? (
                  <Svg svg="crossVisible" />
                ) : (
                  <Svg svg="visible" />
                )}
              </StyleIconWrapper>
            </StyleInputWrapper>

            {!!hasError && <StyleErrorMessage>{meta?.error}</StyleErrorMessage>}
          </StyleFormWrapper>
        )
      }}
    </Field>
  )
}

export default Password
